import { defineMessages } from '@jutro/locale';

export default defineMessages({
    PeopleInvolved: {
        id: 'ml.claim.views.ml-claim-details-ho-involved.People Involved',
        defaultMessage: 'People Involved'
    },
    You: {
        id: 'ml.claim.views.ml-claim-details-ho-involved.You',
        defaultMessage: 'You'
    },
    Phone: {
        id: 'ml.claim.views.ml-claim-details-ho-involved.Phone',
        defaultMessage: 'Phone'
    }
});
